"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  createResource: true,
  createResourceAction: true,
  fetch: true,
  HttpError: true,
  reduceReducers: true,
  combineReducers: true,
  mergeReducers: true
};
exports.createResource = createResource;
exports.createResourceAction = createResourceAction;
Object.defineProperty(exports, "fetch", {
  enumerable: true,
  get: function get() {
    return _fetch.default;
  }
});
Object.defineProperty(exports, "HttpError", {
  enumerable: true,
  get: function get() {
    return _fetch.HttpError;
  }
});
Object.defineProperty(exports, "reduceReducers", {
  enumerable: true,
  get: function get() {
    return _helpers.reduceReducers;
  }
});
Object.defineProperty(exports, "combineReducers", {
  enumerable: true,
  get: function get() {
    return _helpers.combineReducers;
  }
});
Object.defineProperty(exports, "mergeReducers", {
  enumerable: true,
  get: function get() {
    return _helpers.mergeReducers;
  }
});

var _defaults = require("./defaults");

Object.keys(_defaults).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _defaults[key];
    }
  });
});

var _actions2 = require("./actions");

var _reducers2 = require("./reducers");

var _types = require("./types");

var _fetch = _interopRequireWildcard(require("./helpers/fetch"));

var _util = require("./helpers/util");

var _helpers = require("./reducers/helpers");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function createResource(_ref) {
  var resourceName = _ref.name,
      resourcePluralName = _ref.pluralName,
      _ref$actions = _ref.actions,
      givenActions = _ref$actions === void 0 ? {} : _ref$actions,
      _ref$mergeDefaultActi = _ref.mergeDefaultActions,
      mergeDefaultActions = _ref$mergeDefaultActi === void 0 ? true : _ref$mergeDefaultActi,
      _ref$pick = _ref.pick,
      pickedActions = _ref$pick === void 0 ? [] : _ref$pick,
      args = _objectWithoutProperties(_ref, ["name", "pluralName", "actions", "mergeDefaultActions", "pick"]); // Merge passed actions with common defaults


  var resolvedActions = mergeDefaultActions ? (0, _util.mergeObjects)({}, _defaults.defaultActions, givenActions) : givenActions; // Eventually pick selected actions

  if (pickedActions.length) {
    resolvedActions = _util.pick.apply(void 0, [resolvedActions].concat(_toConsumableArray(pickedActions)));
  }

  var types = (0, _types.createTypes)(resolvedActions, _objectSpread({
    resourceName: resourceName,
    resourcePluralName: resourcePluralName
  }, args));
  var actions = (0, _actions2.createActions)(resolvedActions, _objectSpread({
    resourceName: resourceName,
    resourcePluralName: resourcePluralName
  }, args));
  var reducers = (0, _reducers2.createReducers)(resolvedActions, _objectSpread({
    resourceName: resourceName,
    resourcePluralName: resourcePluralName
  }, args));
  var rootReducer = (0, _reducers2.createRootReducer)(reducers, _objectSpread({
    resourceName: resourceName,
    resourcePluralName: resourcePluralName
  }, args));
  return {
    actions: actions,
    reducers: rootReducer,
    // breaking change
    rootReducer: rootReducer,
    types: types
  };
}

function createResourceAction(_ref2) {
  var resourceName = _ref2.name,
      resourcePluralName = _ref2.pluralName,
      _ref2$method = _ref2.method,
      method = _ref2$method === void 0 ? 'GET' : _ref2$method,
      args = _objectWithoutProperties(_ref2, ["name", "pluralName", "method"]);

  var actionId = method.toLowerCase();
  var scope = (0, _types.getTypesScope)(resourceName);
  var types = (0, _types.scopeTypes)((0, _types.createType)(actionId, {
    resourceName: resourceName,
    resourcePluralName: resourcePluralName
  }), scope);
  var actionName = (0, _actions2.getActionName)(actionId, {
    resourceName: resourceName,
    resourcePluralName: resourcePluralName
  });

  var actions = _defineProperty({}, actionName, (0, _actions2.createAction)(actionId, _objectSpread({
    resourceName: resourceName,
    resourcePluralName: resourcePluralName,
    scope: scope
  }, args)));

  var reducers = _defineProperty({}, actionId, (0, _reducers2.createReducer)(actionId, _objectSpread({
    resourceName: resourceName,
    resourcePluralName: resourcePluralName,
    scope: scope
  }, args)));

  var rootReducer = (0, _reducers2.createRootReducer)(reducers, _objectSpread({
    resourceName: resourceName,
    resourcePluralName: resourcePluralName
  }, args));
  return {
    actions: actions,
    reducers: reducers,
    // new API
    rootReducer: rootReducer,
    types: types
  };
}